<template>
  <div ref="chart" style="width: 850px;height:400px;"></div>
</template>

<script>
import echarts from 'echarts'

export default {
  props: {
    userId: {
      type: Number
    }
  },
  data() {
    return {
      ossStorage: [],
      myChart: null,
      option: {
        // backgroundColor: '#0a1a2a',
        // tooltip: {
        //   trigger: 'item',
        //   backgroundColor: '#fff',
        //   formatter: function (params) {
        //     return params.seriesName + '<br/>' + params.marker + '<span style="color:' + params.color + '">' + params.data['name'] + '\n' + params.data['value'] + '</span>';
        //   }
        // },
        series: [
          {
            name: '',
            type: 'pie',
            legendHoverLink: false,
            radius: ['40%', '50%'],
            center: ['45%', '48%'],
            color: [],
            minAngle: 5, //最小角度
            labelLine: {
              show: false
            },
            tooltip: {
              show: false
            },
            emphasis: { scale: false }
          },
          {
            name: '容量信息',
            type: 'pie',
            radius: ['50%', '70%'],
            center: ['45%', '48%'],
            color: [],
            minAngle: 5, //最小角度
            labelLine: {
              smooth: false,
              length: 20,
              length2: 70,
              lineStyle: {
                width: 1
                // color: '#dcdcdc',
              }
            },
            label: {
              formatter: (params) => {
                return `{a|${params.data['name']}}\n{b|${this.filterSize(
                  params.data['value']
                )}}`
              },
              rich: {
                a: {
                  fontWeight: 500,
                  color: '#292929'
                },
                b: {
                  fontWeight: 400,
                  color: '#888888'
                }
              }
              // padding: [0, -65]
            },
            emphasis: {
              scaleSize: 10,
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.28)'
              }
            },
            data: []
          }
        ]
      }
    }
  },
  methods: {
    async getOssStatistics() {
      try {
        let res = await this.$http.getOssStatistics({
          id: this.userId
        })
        for (let i in res.data) {
          if (res.data[i].data) {
            this.ossStorage = [...this.ossStorage, res.data[i]]
          }
        }
        this.initChart()
      } catch (error) {}
    },

    initChart() {
      let color = {
        doc: { value: 'rgba(255,107,107, 1)' },
        left: { value: 'rgba(48,241,230,1)' },
        other: { value: 'rgba(100,247,114,1)' },
        appDate: { value: 'rgba(223,154,255,1)' },
        push: { value: 'rgba(255,220,38, 1)' },
        reader: { value: 'rgba(72,170,255, 1)' },
        share: { value: 'rgba(255,176,112, 1)' }
      }
      let color1 = {
        doc: { value: 'rgba(255,107,107, 0.4)' },
        left: { value: 'rgba(48,241,230,0.4)' },
        other: { value: 'rgba(100,247,114,0.4)' },
        appDate: { value: 'rgba(223,154,255,0.4)' },
        push: { value: 'rgba(255,220,38, 0.4)' },
        reader: { value: 'rgba(72,170,255, 0.4)' },
        share: { value: 'rgba(255,176,112, 0.4)' }
      }

      if (!this.myChart) {
        this.myChart = echarts.init(this.$refs.chart)
      }

      let arr = []
      let arr1 = []
      let colorArr = []
      let colorArr1 = []
      for (let i of this.ossStorage) {
        arr = [
          ...arr,
          { name: this.filterName(i.name), value: i.data <= 0 ? 0 : i.data }
        ]
        arr1 = [...arr1, { name: '', value: i.data <= 0 ? 0 : i.data }]

        if (color[i.name]) {
          colorArr = [...colorArr, color[i.name].value]
          colorArr1 = [...colorArr1, color1[i.name].value]
        }
      }
      this.option.series[0].color = colorArr1
      this.option.series[1].color = colorArr
      this.option.series[0].data = arr1
      this.option.series[1].data = arr
      this.myChart.setOption(this.option)
    },

    filterName(name) {
      let str
      switch (name) {
        case 'doc':
          str = '云端笔记'
          break
        case 'left':
          str = '剩余容量'
          break
        case 'other':
          str = '其他数据'
          break
        case 'push':
          str = '云端推送'
          break
        case 'appDate':
          str = '云端备份'
          break
        case 'reader':
          str = '阅读数据'
          break
        case 'share':
          str = '分享笔记'
          break

        default:
          break
      }
      return str
    },

    filterSize(value) {
      if (value === null || value === '' || !value) {
        return '0 B'
      }
      let unitArr = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
      let index = 0
      let srcsize = parseFloat(value)
      index = Math.floor(Math.log(srcsize) / Math.log(1024))
      var size = srcsize / Math.pow(1024, index)
      //  保留的小数位数
      size = size.toFixed(2)
      return size + unitArr[index]
    }
  },
  mounted() {
    this.getOssStatistics()
  }
}
</script>
